import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ChoferRutaDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Deshabilitado", cell: x => ({ data: x.Deshabilitado }) },
    { title: "Numero Licencia", cell: x => ({ data: x.Identificacion.NumeroLicencia }) }
];

export interface BotonesDeps {
    onDeshabilitar: (item: Entity) => void;
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;

}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Editar",
            style: "primary",
            iconClass: fa("pencil"),
            onClick: deps.onEdit
        },
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onBorrar
        },
        {
            tooltip: "Habilitar",
            style: "success",
            iconClass: fa("bullseye"),
            disabled: x => !x.Deshabilitado,
            onClick: deps.onDeshabilitar
        },
        {
            tooltip: "Deshabilitar",
            style: "warning",
            iconClass: fa("dot-circle-o"),
            disabled: x => x.Deshabilitado,
            onClick: deps.onDeshabilitar
        }
    ]);

    return columna;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/choferruta/list/columns.tsx